import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import 'antd/dist/reset.css';
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

import "@/utils/install";
import "@/stores/install";

import "./App.less";

import Pages from "@/pages";

dayjs.locale("zh-cn");

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        <Pages />
      </div>
    </ConfigProvider>
  );
}

export default App;
